/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { useDispatch } from "react-redux";
import { useAuth } from "cms/auth/hooks/use-auth";
import { Logger } from "cms/utils/log/logger";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import {
    setSelectedNodeId,
    setWebsiteItem,
    setCurrentWebsite
} from "data/store/reducers/website";
import { 
    setApplications,
    setApplicationItem
} from "data/store/reducers/application";


const useApplication = function () {
    
    const dispatch = useDispatch();
    const { token = "" } = useAuth();
    const [hasWebsite, setHasWebsite] = useState(false);
    
    // TODO:
    //    add first application id to browser local storage on first use.
    //    save the selected website to local storage on selection
    //    load the first/selected website from that id.
    //    -
    //    Current, approach loads all applications and the related websites
    
    const fetchApplicationData = async (last_app_id, domain) => {
        Logger.debug("[use-application] get applications");
        // lookup and set applications
        const apps = await SimpliCityAdminSDK.application.find(token);
        dispatch(setApplications(apps));
        const webs = [];
        for (const app of apps) {
            dispatch(setApplicationItem(app));
            // localStorage.setItem('CurrentApplication', app.guid)
            const { type, guid: app_id } = app || {};
            if (type === "website") {
                if (app_id) {
                    // lookup and set website
                    const website = await SimpliCityAdminSDK.website.findForApplication(token, app_id);
                    if (website) {
                        webs.push(website);
                        dispatch(setWebsiteItem(website));
                        const domains = website.domains;
                        for (const dom of domains) {
                            const str = "https://" + dom;
                            // Logger.debug(`%c[use-application] domain ${str}`, `color: #27e7f5`)
                            // const str = dom.domain
                            const domUrl = new URL(str);
                            const domHost = domUrl.hostname;
                            if (domHost === domain) {
                                dispatch(setCurrentWebsite(website));
                                if (!hasWebsite) {
                                    setHasWebsite(true);
                                    Logger.debug(`[use-application] set selected node as ${website.home}`);
                                    dispatch(setSelectedNodeId(website.home));
                                }
                            }
                        }
                    }
                }
            }
        }
        Logger.debug("[use-application] Website and application data loaded.");
    };
    
    // FIXME: the previous below does not match the above
    // const fetchApplicationData = async (token) => {
    //     Logger.debug('Loading application amd website data...')
    //     Logger.flush()
    //
    //     if (isStringNotEmpty(app_id)) {
    //         localStorage.setItem('CurrentApplication', app_id)
    //         const website = await SimpliCityAdminSDK.website.findForApplication(token, app_id)
    //         if (website) {
    //             // webs.push(website)
    //             dispatch(setWebsiteItem(website))
    //             if (!hasWebsite) {
    //                 setHasWebsite(true)
    //                 Logger.debug(`set selected node as ${website.home}`)
    //                 Logger.flush()
    //                 dispatch(setSelectedNodeId(website.home))
    //                 dispatch(setWebsiteHome(website.home))
    //             }
    //         }
    //     } else {
    //
    //         // lookup and set applications
    //         const apps = await SimpliCityAdminSDK.application.find(token)
    //         dispatch(setApplications(apps))
    //         if (isArrayNotEmpty(apps)) {
    //             const first_app = apps[0]
    //             const first_app_id = first_app.guid
    //             localStorage.setItem('CurrentApplication', first_app_id)
    //         }
    //         for (const app of apps) {
    //             dispatch(setApplicationItem(app))
    //             const {type, guid: app_id} = app || {}
    //             if (type === 'website') {
    //                 if (app_id) {
    //                     // lookup and set website
    //                     let website
    //                     try {
    //                         // website = await SimpliCityAdminSDK.website.findForDomain(token, hostname)
    //                         website = await SimpliCityAdminSDK.website.findForApplication(token, app_id)
    //                         // Logger.warn(website)
    //                         // Logger.flush()
    //                     } catch (error) {
    //                         Logger.error(error)
    //                         Logger.flush()
    //                     }
    //
    //                     // const website = await SimpliCityAdminSDK.website.findForApplication(token, app_id)
    //                     if (website) {
    //                         // webs.push(website)
    //                         dispatch(setWebsiteItem(website))
    //                         if (!hasWebsite) {
    //                             setHasWebsite(true)
    //                             Logger.debug(`set selected node as ${website.home}`)
    //                             Logger.flush()
    //                             dispatch(setSelectedNodeId(website.home))
    //                             dispatch(setWebsiteHome(website.home))
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     Logger.info('Website and application data loaded.')
    // }
    
    return {
        fetchApplicationData
    };
};

export { useApplication };
